import { useEffect, useMemo } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { createMongoAbility } from '@casl/ability'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

//store
import AuthService from '../store/auth/AuthService';

// snackbar
import useSnackbarStore from '../store/snackbar';

// error handler
import handleErrors  from '../utils/errorHandler';

const useAuth = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const queryClient = useQueryClient()

    const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

    const { data, isLoading } = useQuery({
        queryKey: ['auth'],
        queryFn: AuthService.getMe,
        staleTime: 5 * 60 * 1000,
        retry: false
    })

    const user = data?.user

    useEffect(() => {
        if (!user || location.pathname !== '/login') return

        const returnTo = searchParams.get('returnTo') || '/'
        navigate(returnTo)
    }, [user?.user_id])

    const ability = useMemo(() => {
        return createMongoAbility(user?.permissions || [])
    }, [user?.permissions])

    const loginMutation = useMutation({
        mutationKey: ["login"],
        mutationFn: AuthService.login,
        onSuccess: (userData, { formikHelpers }) => {
            queryClient.setQueryData(['auth'], userData)
            formikHelpers.setSubmitting(false);
          },
          onError: (error, { formikHelpers }) => {
            let message = handleErrors(error, formikHelpers.setErrors);
            if (message) showSnackbar(message, 'error');
            formikHelpers.setSubmitting(false);
          }
    })


    const logoutMutation = useMutation({
        mutationFn: AuthService.logout,
        onSuccess: () => {
            queryClient.setQueryData(['auth'], null)
            queryClient.clear()
        },
    })

    // const refreshMutation = useMutation({
    //     mutationFn: async () => {
    //         await axios.post('/auth/refresh')
    //     },
    //     onSuccess: () => {
    //         queryClient.invalidateQueries(['auth'])
    //     },
    //     onError: () => {
    //         queryClient.setQueryData(['auth'], null)
    //     },
    // })

    return {
        user,
        ability,
        isAuthenticated: !!user,
        isLoading,

        login: loginMutation.mutateAsync,
        isLoggingIn: loginMutation.isPending,
        logSuccess: loginMutation.isSuccess,
        loginError: loginMutation.error,

        logout: logoutMutation.mutateAsync,
        isLoggingOut: logoutMutation.isPending,

        // refresh: refreshMutation.mutateAsync,
        // isRefreshing: refreshMutation.isPending,
    }
}

export default useAuth;